<template>
    <div class="home">
        <navbar></navbar>
        <div class="main">
            <div class="detail_waper" v-show="hasCertificate">
                <img :src="imgSrc" v-show="imgSrc">
                <img :src="img_certificateExtraUrl" v-show="img_certificateExtraUrl">
            </div>
            <div class="download_btn" @click="downloadExportFile" v-show="hasCertificate">
                下载证书
            </div>
            <div class="None" v-show="!hasCertificate">暂无证书</div>
            <footer-page></footer-page>
        </div>
        <div class="fixed-products-content-right-btn">
            <div class="fixed-products-content-ph">
                <p>培训业务咨询：</p>
                <p>010-88484118-826/862/822</p>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import FooterPage from '@/components/footer.vue'
import navbar from '@/components/nav.vue'
import { getcertificate, PersonalReport } from '@/api/api.js'
import download from 'downloadjs'; // 引用插件
export default {
    name: "index",
    components: {
        navbar,
        FooterPage
    },
    data() {
        return {

            downloadUrl: '',
            userId: '',
            imgSrc: '',
            img_certificateExtraUrl: '',
            detailId: '',
            loading: true,
            isMenu: true,
        }
    },
    computed: {
        // 是否有证书图片
        hasCertificate() {
            return this.imgSrc || this.img_certificateExtraUrl;
        }
    },
    methods: {
        openMenu() {
            this.isMenu = !this.isMenu
        },
        goIndex() {
            this.$router.push({
                path: 'IndexPage'
            })
        },
        getImgUrl() {
            getcertificate(this.id).then(response => {
                if (response.code == 200) {
                    this.imgSrc = response.data?.[0]?.certificatePublicUrl || null;
                    this.img_certificateExtraUrl = response.data?.[0]?.certificateExtraUrl || null;
                } else {
                    this.$message.error(response.msg);
                }
            })
        },
        downloadExportFile() {
            this.openUlr(this.imgSrc)
            this.openUlr(this.img_certificateExtraUrl)
            PersonalReport(this.id).then(response => {
                if (response.code == 200) return true
            })
        },
        openUlr(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id
            this.getImgUrl();
        }
    },

}
</script>
<style scoped>
.detail_waper {
    /* background-color: rgba(230, 230, 230, 0.4); */
    height: 140px;
    margin-top: 15px;
    /*  width: 510px;
    height: 700px;*/
    margin: 15px auto auto auto;
    height: 700px;
    display: flex;
    justify-content: center;
    gap: 40px;
}

.detail_waper img {
    /* width: 100%;*/
    width: 510px;
    height: 700px;
}

.download_btn {
    background: #5EB454;
    color: #fff;
    border-radius: 5px;
    width: 135px;
    height: 40px;
    line-height: 40px;
    margin: 50px auto auto auto;
    text-align: center;
    cursor: pointer;
}

.fixed-products-content-right-btn {
    position: fixed;
    right: -20px;
    top: 465px;
    z-index: 999;
    opacity: 1;
    background: #fff;
    box-shadow: 0px 0px 15px -8px rgb(0 0 0 / 50%);
    color: #000;
    height: 47.5px;
    width: 275px;
    margin: 0 auto;
    border-radius: 50px;
    margin-top: 36px;
    font-size: 14px;
    text-indent: 55px;
    padding-top: 7.5px;
}

.fixed-products-content-ph {
    background-image: url(http://www.cebpubservice.com/custom/img/tel.png);
    background-repeat: no-repeat;
    background-position: 20px center;
    background-size: 26px;
}

.fixed-products-content-right-btn p {
    height: 20px;
    margin: 0;
}


.fixedTip {
    position: fixed;
    height: 100px;
    padding: 15px 0px;
    width: 170px;
    z-index: 999;
    top: 50%;
    left: 0%;
    margin-top: -50px;
    margin-left: 0;
}


.bg {
    background-color: rgba(220, 220, 220, .4);
    border-radius: 8px;
}


.None {
    font-size: 48px;
    color: #7d7474;
    text-align: center;
    line-height: 250px;
    font-family: cursive;
    font-weight: bold;
}
</style>